module.exports = __webpack_public_path__ + "7e34def64a0f45c1bcb6a9764a5ba4b1.svg";